export enum DealSizeCellBlock {
  Root = 'DealSizeCell',
}
